export default "__VITE_PUBLIC_ASSET__c842304e__"